export default __webpack_public_path__ + "static/media/logo-musaned-white.c7aec498.svg";